import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import styles from '../Sales/PaymentInformation/PaymentMethod.module.css';

export const CompanyEmailConfirmation = ({ isOpen, centered, onCancel, onConfirm, email }) => {
    return (
        <Modal
            isOpen={isOpen}
            className='deleteCard'
            centered={centered}
        >
            <div className={styles.deleteCardHeader}>
                <h4>Update Login Email</h4>
            </div>

            <ModalBody>
                <p>Updating your company email will change your login email to {email}. Would you like to proceed?</p>
            </ModalBody>

            <ModalFooter>
                <button
                    className='btnLink'
                    onClick={onCancel}
                >
                    Cancel
                </button>

                <button
                    className='btn-primary'
                    onClick={onConfirm}
                >
                    Confirm
                </button>
            </ModalFooter>
        </Modal>
    );
};
